<template>
  <a-error>
    <template #title>
      {{ text }}
      <template v-if="post.violations.length > 0">
        {{ $translate('post.other.violationReasonText') }}
        <template v-for="violation in post.violations" :key="violation.id">
          {{ violation.description }}{{ ' ' }}
        </template>
      </template>
    </template>
  </a-error>
</template>

<script>
import { SettingsStatus } from '@/model/data-object/Post'
import AError from '@/components/Post/SinglePost/AError'

export default {
  name: 'PostSingleViolation',
  components: { AError },
  props: {
    post: {
      type: Object,
      required: true,
    },
    isParentViolation: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    text() {
      if (this.post.status === SettingsStatus.GDPR_DELETED) {
        if (this.isParentViolation) {
          return this.$translate('post.texts.gdprBlockedParent')
        }
        return this.$translate('post.texts.gdprBlocked')
      }
      if (this.post.status === SettingsStatus.HIDDEN) {
        if (this.isParentViolation) {
          return this.$translate('post.texts.blockedParent')
        }
        return this.$translate('post.texts.blocked')
      }
      return ''
    },
  },
}
</script>
